import { EventBus, Topics, Types } from '@/event-bus'
import store from '@/store'

const handlerError = (data) => {
  if (!data.response) {
    if (data.code === 'ECONNABORTED') {
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Tempo de requisição esgotado, tente novamente',
        type: Types.DANGER,
      })
      return
    }

    if (data.code === 'ERR_NETWORK') {
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Erro de conexão, tente novamente',
        type: Types.DANGER,
      })
      return
    }

    EventBus.$emit(Topics.NOTIFICATIONS, {
      message: 'Ocorreu um erro inesperado, entre em contato com o suporte',
      type: Types.DANGER,
    })

    return
  }

  let message

  switch (data.response.status) {
    case 500:
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message:
          data.response.data.message ||
          data.response.error ||
          'Ocorreu um erro inesperado, entre em contato com o suporte',
        type: Types.DANGER,
      })
      break
    case 400:
      if (Array.isArray(data.response.data)) {
        message = data.response.data.map((e) => e.message)
      } else if (data.response.data.error) {
        message = data.response.data.error
      } else {
        message = Object.keys(data.response.data.data).map(
          (e) => data.response.data.data[e]
        )
      }

      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: message,
        type: Types.WARNING,
      })
      break
    case 401:
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Você precisa estar logado para realizar essa ação',
        type: Types.DANGER,
      })
      store.dispatch('logout')
      break
    case 403:
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Sem acesso a esse recurso',
        type: Types.DANGER,
      })
      break
    default:
      EventBus.$emit(Topics.NOTIFICATIONS, {
        message: 'Ocorreu um erro inesperado',
        type: Types.DANGER,
      })
      break
  }
}

const createHttpClient = (
  client,
  mapResponse = (response) => response.data.data
) => {
  return {
    async get(url, data = {}, showNotification = true) {
      try {
        const response = await client.get(url, { params: { ...data } })
        return mapResponse(response)
      } catch (e) {
        if (showNotification) {
          handlerError(e)
        }
        return null
      }
    },
    // GET de texto puro (respostas streamadas, ex.: conteudo original de arquivo)
    // — nao passa pelo envelope { data } do backend; devolve o corpo cru.
    async getText(url, data = {}, showNotification = true) {
      try {
        const response = await client.get(url, {
          responseType: 'text',
          transformResponse: (body) => body,
          params: { ...data },
        })
        return response.data
      } catch (e) {
        if (showNotification) {
          handlerError(e)
        }
        return null
      }
    },
    async getDownload(url, data = {}) {
      try {
        return await client.get(url, {
          responseType: 'blob',
          params: { ...data },
        })
      } catch (e) {
        handlerError(e)
        return null
      }
    },
    async getDownloadStream(url, data = {}, onUpdateProgress = null) {
      try {
        const startTime = new Date().getTime()

        return await client.get(url, {
          responseType: 'blob',
          params: { ...data },
          onDownloadProgress: (progressEvent) => {
            const percentComplete = Math.floor(
              (progressEvent.loaded / progressEvent.total) * 100
            )

            const duration = (new Date().getTime() - startTime) / 1000
            const bps = progressEvent.loaded / duration

            const kbps = Math.floor(bps / 1024)

            const time = (progressEvent.total - progressEvent.loaded) / bps
            const seconds = Math.floor(time % 60)
            const minutes = Math.floor(time / 60)

            if (onUpdateProgress) {
              onUpdateProgress({
                percentComplete,
                kbps,
                duration,
                time: `${minutes}:${seconds}`,
              })
            }
          },
        })
      } catch (e) {
        handlerError(e)
        return null
      }
    },
    async delete(url, id, showNotification = true) {
      try {
        const response = await client.delete(url, { data: { id } })

        if (showNotification) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Recurso deletado com sucesso',
            type: Types.INFO,
          })
        }

        return mapResponse(response)
      } catch (e) {
        handlerError(e)
        return null
      }
    },
    async put(url, data = {}, showNotification = true) {
      try {
        const response = await client.put(url, data)

        if (showNotification) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Recurso atualizado com sucesso',
            type: Types.INFO,
          })
        }

        return mapResponse(response)
      } catch (e) {
        handlerError(e)
        return null
      }
    },
    async patch(url, data = {}, showNotification = true) {
      try {
        const response = await client.patch(url, data)

        if (showNotification) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Recurso atualizado com sucesso',
            type: Types.INFO,
          })
        }

        return mapResponse(response)
      } catch (e) {
        handlerError(e)
        return null
      }
    },
    async post(url, data = {}, showNotification = true) {
      try {
        const response = await client.post(url, data)

        if (showNotification) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Recurso criado com sucesso',
            type: Types.INFO,
          })
        }

        return mapResponse(response)
      } catch (e) {
        if (showNotification) {
          handlerError(e)
        }
        return null
      }
    },
    async postForm(url, data = {}, showNotification = true) {
      try {
        const response = await client.postForm(url, data)

        if (showNotification) {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Recurso criado com sucesso',
            type: Types.INFO,
          })
        }

        return mapResponse(response)
      } catch (e) {
        if (showNotification) {
          handlerError(e)
        }
        return null
      }
    },
  }
}

export { createHttpClient, handlerError }
